import Api, { PerformerRequest, Unit } from '@silbo/core';

export const getRequestsQuery = (units: Unit[]) =>
  new Api.Query(PerformerRequest)
    .equalTo('status', 'REQUESTED')
    .include([
      'request',
      'request.visit',
      'request.visit.thesaurusItem',
      'request.originAccommodation.unit',
      'request.originAccommodation.bed',
      'performer',
    ])
    .containedIn('performer', units)
    .ascending('createdAt');
